import { useState } from "react";

import api from "../../api/axios"; //   axios instance
import { Link } from "react-router-dom";

const GENERIC_MESSAGE = "If that email exists, we sent a reset link.";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // The API always answers with the same message and never returns a token: the link is emailed.
      const res = await api.post("/api/forgot-password", { email });
      setMessage(res.data?.message || GENERIC_MESSAGE);
    } catch (err) {
      setMessage(
        err.response?.status === 429
          ? "Too many attempts. Please wait a few minutes and try again."
          : GENERIC_MESSAGE
      );
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
  <div className="card p-4 shadow-lg" style={{ maxWidth: "400px", width: "100%" }}>
    <h2 className="text-center mb-4">Forgot Password</h2>
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <input
          type="email"
          className="form-control"
          placeholder="Enter your email"
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <button type="submit" className="btn btn-primary w-100 mb-2">
        Send Reset Link
      </button>
    </form>
    {message && <p className="text-center text-success">{message}</p>}
    <div className="text-center mt-3 d-flex flex-column gap-2">
      <Link to="/otp">Reset via SMS OTP</Link>
      <Link to="/">Back to Login</Link>
    </div>
  </div>
</div>

  );
}

export default ForgotPassword;
